import styled from 'styled-components'

const LayoutsContainerUi = styled.div`
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
`

export default LayoutsContainerUi
